import { useState, useEffect } from 'react';
import { Keyboard, EmitterSubscription } from 'react-native';

function useKeyboardStatus(): boolean {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const showSubscription: EmitterSubscription = Keyboard.addListener('keyboardDidShow', () => setIsOpen(true));
    const hideSubscription: EmitterSubscription = Keyboard.addListener('keyboardDidHide', () => setIsOpen(false));

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, []);

  return isOpen;
}

export default useKeyboardStatus;
